const textSpec = {
  passwordMustHaves: {
    header: 'A password must:',
    length: 'Be at least 8 characters long',
    capitalLetter: 'Contain at least 1 capital letter',
    number: 'Contain at least 1 number',
    symbol: 'Contain at least 1 symbol (!, ? etc.)',
  },
}

const PasswordRequirements = () => {
  return (
    <div className="mb-[30px] w-full">
      <p className="mb-1 text-sm font-semibold">{textSpec.passwordMustHaves.header}</p>
      <ul className="text-sm list-disc list-inside text-gray-600">
        <li>{textSpec.passwordMustHaves.length}</li>
        <li>{textSpec.passwordMustHaves.capitalLetter}</li>
        <li>{textSpec.passwordMustHaves.number}</li>
        <li>{textSpec.passwordMustHaves.symbol}</li>
      </ul>
    </div>
  )
}

export default PasswordRequirements
